import DetailsUse from "components/Atoms/SharedComponents/CRUD/details-use";
import { useTranslation } from "react-i18next";
import { detailsData } from "templates/vendor/vendorListing/details";

export default function Details({ details }) {
  const { t } = useTranslation();
  return (
    <DetailsUse
      data={{
        deleteBtn: false,
        editBtn: false,
        data: {
          list: detailsData({ data: details, t }),
        },
      }}
    />
  );
}
